<template>

  <a class="artist-person__item" :href="getArtistUrl(artist)" style="text-decoration: none">
    <div class="artist-person__overlay">
      <img class="artist-person__img lazyload" :data-src="getMediaSrc(artist.media, 'sx800')"/>
    </div>

    <div class="artist-person__info">
      <div v-if="artist.first_name || artist.middle_name" class="artist-person__subname">
        <p>
          {{ artist.first_name }}
          {{ artist.middle_name }}
        </p>
      </div>

      <div v-if="artist.last_name" class="artist-person__name">
        <p>
          {{ artist.last_name }}
        </p>
      </div>


      <div class="artist-person__count">
        <p>
          <span v-if="artist.countries && artist.countries.length>0">
            {{ artist.countries[0].name }}
          </span>

          <!-- не вывожу количество работ, т.к. тут надо выводить количество работ этого худождника в этой галерее -->
          <!--<xsl:call-template name="f_str_implode">
            <xsl:with-param name="glue"><xsl:text>, </xsl:text></xsl:with-param>
            <xsl:with-param name="str1"><xsl:call-template name="m_artists_show_country">
              <xsl:with-param name="with_link">0</xsl:with-param>
            </xsl:call-template></xsl:with-param>
            <xsl:with-param name="str2"><xsl:if test="count_works/total>0">
              <xsl:call-template name="f_plural_form">
                <xsl:with-param name="is_show_num">0</xsl:with-param>
                <xsl:with-param name="num" select="count_works/total"/>
                <xsl:with-param name="str1">%1$s работа</xsl:with-param>
                <xsl:with-param name="str2">%1$s работы</xsl:with-param>
                <xsl:with-param name="str5">%1$s работ</xsl:with-param>
              </xsl:call-template>
            </xsl:if></xsl:with-param>
          </xsl:call-template>-->
        </p>
      </div>
    </div>
  </a>

</template>

<script>

  import WorksItemMix from "../../../../components/list/WorksItemMix";

  export default {
    name: 'artists-itemsub',
    props: {
      artist: [Array, Object],
    },
    data() {
      return {
        is_subdomain: $('#app-wrapper').attr('is_subdomain'),
      }
    },
    mixins: [WorksItemMix],

    computed : {
      userId: {
        get() {
          return this.$store.getters.userId
        }
      },
    },

    methods : {
      getUserUrl(user) {
        if ( user.link!=null && user.link.length>0 ) return user.link;

        let res='';
        if ( user.nickname!=null && user.nickname.length>0 ) res='/'+user.nickname;
        else res='/users/'+user.user_id;

        if ( res.substr(0,1)=='/' ) res=res.substr(1);
        res=document.site_short_url_lang + res;

        return res;
      },

      //use @click="slide_show(set, $event)"
      /*slide_show(set, event) {
        if (window._GL_works_without_slideshow === 'y') {
          window.location.href = this.getSetUrl(set);
          stop_bubble(event);
          return false;
        }

        model_slideshow_v8.do_show(this, '', null, set.slideshow_uri, '0', '', event);
        stop_bubble(event);
        return false;
      },*/
    },

    /*mounted (){
      let id=window.global.get_or_gen_id( $(this.$refs.cardimages) );
      window.page_artists_works.do_load_artists_works(this.artist.artist_id, id);
    },*/
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/list/ArtistsItemSub.vue